export const STATUS_CODE: {[key:string] : number } = {
    OK: 200,
    BAD_REQUEST: 400,
    UNAUTHORIZED:401,
    FORBIDDEN: 403,
    PAGE_NOT_FOUND: 404,
    UNEXPECTED_ERROR: 500
  }